import { Link } from "react-router-dom";
import SupportButton from "./SupportButton";

const Footer = () => {
  return (
    <footer
      id="footer"
      className="text-center  pt-2"
      style={{
        backgroundColor: "#f6f8fa",
        borderTop: "1px solid rgba(0, 0, 0, 0.125)",
      }}
    >
      <span className="text-uppercase" style={{ fontSize: "12px" }}>
        &copy;{new Date().getFullYear()}{" "}
        <a
          href="https://mifotra.gov.rw"
          target="_blank"
          rel="noreferrer"
          className="text-dark"
        >
          Ministry of Public Service and Labour (MIFOTRA)
        </a>
      </span>

      <div className="" style={{ fontSize: "10px" }}>
        <a
          className=" my-sm-0  text-uppercase"
          rel="noreferrer"
          href="http://recruitment.mifotra.gov.rw"
          target="_blank"
        >
          E-Recruitment
        </a>{" "}
        |{" "}
        <a
          className=" my-sm-0  text-uppercase"
          rel="noreferrer"
          href="https://ippis.rw"
          target="_blank"
        >
          IPPIS
        </a>{" "}
        |{" "}
        <Link className=" my-sm-0  text-uppercase" to="#">
          About IPPIS
        </Link>
      </div>

      <SupportButton content={<></>} title={"Welcome"} />
    </footer>
  );
};

export default Footer;
